import Vuex from 'vuex';
import Vue from 'vue';
import { GAME_SESSION_NAMESPACE } from './modules/game-session/game-session.constants.js';
import { gameSession } from './modules/game-session/game-session.store.js';

var _a;
Vue.use(Vuex);
var store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: (_a = {},
        _a[GAME_SESSION_NAMESPACE] = gameSession,
        _a),
});

export { store };
